import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { CryptoHelper } from "app/helpers/cryptoHelper";
import { WithdrawDetailsType } from "app/types/cryptoType";
import { UserType } from "app/types/userType";
import React, { Component, MouseEventHandler } from "react";
import { FormattedMessage } from "react-intl";
import "./CryptoFundingWithdrawPending.scss";
type Props = {
  withdrawDetails: WithdrawDetailsType;
  currency: string;
  user: UserType;
  backToHomepage: MouseEventHandler;
  cancelWithdraw: MouseEventHandler;
};

class CryptoFundingWithdrawPending extends Component<Props> {
  render() {
    const { currency, withdrawDetails, user, backToHomepage, cancelWithdraw } =
      this.props;

    return (
      <React.Fragment>
        <div className="crypto-funding-withdraw-pending">
          <div className="crypto-funding-withdraw-pending__title">
            <FormattedMessage id="cashier-withdrawal-pending" />
          </div>
          <div className="crypto-funding-withdraw-pending__amount">
            <div>
              <FormattedMessage id="cashier-amount" />
              {`(${user["currencyCode"]}): `}
              {withdrawDetails.amountSending}
            </div>
            <div>
              <FormattedMessage id="cashier-amount" />
              {`(${currency.replace(/_/g, "-")}): `}
              {withdrawDetails.receiveQuantity}
            </div>
          </div>
          <div className="crypto-funding-withdraw-pending__title">
            {"TXHASH"}
          </div>
          {withdrawDetails.txHash ? (
            <a
              className={"crypto-funding__link"}
              target="_blank"
              rel="noreferrer"
              href={CryptoHelper.getBlockchainURL(
                currency,
                withdrawDetails.txHash
              )}
            >
              {withdrawDetails.txHash}
            </a>
          ) : (
            <div className="crypto-funding-withdraw-pending__transaction-id">
              <FormattedMessage tagName="span" id="cashier-processing" />
              <LoadingSpinner spinner="moon" />
            </div>
          )}
        </div>
        <div className="crypto-funding-withdraw-pending__bottom-section">
          <div className="crypto-funding-withdraw-pending__bottom-section__messages">
            <FormattedMessage
              tagName="div"
              id="cashier-pending-withdraw-start"
            />
            <FormattedMessage
              tagName="div"
              id="cashier-withdrawal-network-load"
            />
          </div>
          {withdrawDetails.txHash && (
            <div className="crypto-funding-withdraw-pending__bottom-section__messages">
              <FormattedMessage
                tagName="span"
                id="cashier-pending-withdraw-track"
              />{" "}
              <a
                rel="noreferrer"
                target="_blank"
                href={CryptoHelper.getBlockchainURL(
                  currency,
                  withdrawDetails.txHash
                )}
              >
                <FormattedMessage tagName="span" id="reports-here" />
              </a>{" "}
              <FormattedMessage
                tagName="span"
                id="cashier-pending-withdraw-end"
              />
            </div>
          )}
          <div className="crypto-funding-withdraw-pending__buttons-section">
            <div className="crypto-funding-withdraw-pending__buttons-section__buttons">
              <button onClick={backToHomepage}>
                <FormattedMessage tagName="span" id="cashier-back-homepage" />
              </button>
              <button className="error-button" onClick={cancelWithdraw}>
                <FormattedMessage tagName="span" id="button-cancel" />
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CryptoFundingWithdrawPending;
